import * as React from 'react';

import {
  BooleanInput,
  Create,
  ImageField,
  ImageInput,
  NumberInput,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
  useTranslate,
} from 'react-admin';

import { MyTranslatableInputs } from '../../../components/MyTranslatableInputs';

const SectionsCreate = () => {
  const translate = useTranslate();

  return (
    <Create>
      <SimpleForm>
        {/* <TextInput
          source="name"
          label={translate('resources.sections.fields.name')}
          validate={[required()]}
        /> */}
        <MyTranslatableInputs groupKey="name">
          <TextInput
            source="nameTranslated"
            label={translate('resources.sections.fields.name')}
            validate={[required()]}
          />
        </MyTranslatableInputs>
        <SelectInput
          source="currency"
          defaultValue="€"
          label={translate('resources.sections.fields.currency')}
          validate={[required()]}
          choices={[
            { id: '€', name: '€' },
            // { id: '€', name: '€' },
            { id: 'zł', name: 'zł' },
          ]}
        />
        <BooleanInput
          source="showErrorCodes"
          label={translate('resources.sections.fields.showErrorCodes')}
          fullWidth
        />
        <ImageInput
            source="image"
            label={translate('resources.series.fields.photo')}
            accept="image/*"
            multiple={false}
            validate={[required()]}
          >
            <ImageField source="src" title="title" />
          </ImageInput>
        <NumberInput
          source="order"
          label={translate('resources.sections.fields.order')}
          min={1}
          max={99}
          step={1}
          defaultValue={99}
          validate={[required()]}
          style={{ width: 160 }}
        />
      </SimpleForm>
    </Create>
  );
};

export default SectionsCreate;
